var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_66",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.133362,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.63337 19.5C5.25133 19.5 4.07249 19.0199 3.09684 18.0596C2.12121 17.0994 1.63339 15.9282 1.63339 14.5462C1.63339 13.3231 2.02506 12.2353 2.80839 11.2827C3.59173 10.3302 4.59108 9.76671 5.80647 9.59236C6.12698 8.09747 6.87858 6.87503 8.06127 5.92503C9.24395 4.97503 10.6013 4.50003 12.1334 4.50003C13.9423 4.50003 15.4779 5.13112 16.7401 6.39331C18.0023 7.65547 18.6333 9.19104 18.6333 11V11.5H18.941C19.9949 11.5821 20.8737 12.0058 21.5776 12.7712C22.2814 13.5366 22.6333 14.4462 22.6333 15.5C22.6333 16.6154 22.2455 17.5609 21.4699 18.3365C20.6942 19.1122 19.7487 19.5 18.6334 19.5H6.63337ZM6.63337 18H18.6334C19.3334 18 19.925 17.7583 20.4084 17.275C20.8917 16.7917 21.1334 16.2 21.1334 15.5C21.1334 14.8 20.8917 14.2083 20.4084 13.725C19.925 13.2417 19.3334 13 18.6334 13H17.1334V11C17.1334 9.61667 16.6459 8.43751 15.6709 7.46251C14.6959 6.48751 13.5167 6.00001 12.1334 6.00001C10.75 6.00001 9.57087 6.48751 8.59587 7.46251C7.62087 8.43751 7.13337 9.61667 7.13337 11H6.63337C5.6667 11 4.8417 11.3417 4.15837 12.025C3.47503 12.7083 3.13337 13.5333 3.13337 14.5C3.13337 15.4667 3.47503 16.2917 4.15837 16.975C4.8417 17.6583 5.6667 18 6.63337 18Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.1e41a3e3f973a01a825509fd40d51ad5.svg";
export { ForwardRef as ReactComponent };